<div *transloco="let t">
  <div
    class="table-of-contents_wrap"
    [class.visually-hidden]="isEmpty">
    <h3 class="table-of-contents_heading">
      <span
        class="link __black __complex __dashed"
        (click)="isExpanded = !isExpanded"
        ngPreserveWhitespaces>
        <app-icon
          name="triangle-arrow"
          [classes]="!isExpanded ? '__right' : ''"
          top="-3px"></app-icon>
        <span
          class="link_u"
          [innerHTML]="t('table-of-contents.heading')"></span>
      </span>
    </h3>

    <ul
      #tableOfContents
      class="table-of-contents"
      [class.visually-hidden]="!isExpanded">
      <!-- Generated content will be here -->
    </ul>
  </div>
</div>

<div #content>
  <ng-content></ng-content>
</div>
